export interface FocusTarget {
  focus(): void;
}

export interface ModalFocusState {
  wasOpen: boolean;
}

export function synchronizeModalFocus(
  open: boolean,
  state: ModalFocusState,
  initialTarget: FocusTarget | null,
  returnTarget: FocusTarget | null,
): void {
  if (open) {
    state.wasOpen = true;
    initialTarget?.focus();
  } else if (state.wasOpen) {
    state.wasOpen = false;
    returnTarget?.focus();
  }
}

export function cycleModalTab(
  event: { shiftKey: boolean; preventDefault(): void },
  focusable: readonly FocusTarget[],
  activeTarget: FocusTarget | null,
): void {
  if (focusable.length === 0) return;
  const first = focusable[0]!;
  const last = focusable[focusable.length - 1]!;
  if (event.shiftKey && (activeTarget === first || !focusable.includes(activeTarget!))) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && (activeTarget === last || !focusable.includes(activeTarget!))) {
    event.preventDefault();
    first.focus();
  }
}
